<sh-card id="at-neocor-logs-card" card-height="232px">
  <div class="content">
    <sh-icon
      id="at-neocor-logs-icon"
      icon="list-viewmode"
      size="l"
      disabled
    ></sh-icon>
    <div class="text-content">
      <sh-text
        id="at-neocor-logs-label"
        size="header-2"
        [innerHTML]="'atNeocorApplications.label.logs' | translate"
      ></sh-text>
      <sh-text
        id="at-neocor-logs-message"
        [innerHTML]="'atNeocorApplications.message.logs' | translate"
      ></sh-text>
    </div>
    <sh-button
      id="at-neocor-logs-button"
      [label]="'atNeocorApplications.label.logsButton' | translate"
      size="max-content"
      [link]="
        (atApplicationsLink | async)?.atLogCompanionUrl
          ? ((atApplicationsLink | async)?.atLogCompanionUrl
            | processPlaceholders)
          : null
      "
      [disabled]="
        (atApplicationsLink | async)?.atLogCompanionUrl ? false : true
      "
      (click)="openLink($event.target.link)"
    ></sh-button>
  </div>
</sh-card>

<sh-card id="at-neocor-sonar-card" card-height="232px">
  <div class="content">
    <sh-icon
      id="at-neocor-sonar-icon"
      icon="analytics"
      size="l"
      disabled
    ></sh-icon>
    <div class="text-content">
      <sh-text
        id="at-neocor-sonar-label"
        size="header-2"
        [innerHTML]="'atNeocorApplications.label.sonar' | translate"
      ></sh-text>
      <sh-text
        id="at-neocor-sonar-message"
        [innerHTML]="'atNeocorApplications.message.sonar' | translate"
      ></sh-text>
    </div>
    <sh-button
      id="at-neocor-sonar-button"
      [label]="'atNeocorApplications.label.sonarButton' | translate"
      size="max-content"
      [link]="
        (atApplicationsLink | async)?.atSonarDashboardUrl
          ? ((atApplicationsLink | async)?.atSonarDashboardUrl
            | processPlaceholders)
          : null
      "
      [disabled]="
        (atApplicationsLink | async)?.atSonarDashboardUrl ? false : true
      "
      (click)="openLink($event.target.link)"
    ></sh-button>
  </div>
</sh-card>
